module.exports = __webpack_public_path__ + "static/img/login_sub.8cd5f43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login_sub.png
// module id = zCZe
// module chunks = 1